var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.825,
    height: 29.321,
    viewBox: "0 0 59.825 29.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2f3061;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-638.994 -882.131)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(638.994 882.131)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M638.994,911.44V882.131h59.719l.106.116c-.3.27-.619.526-.9.813q-13.927,13.927-27.841,27.865a1.6,1.6,0,0,1-1.243.528q-14.5-.023-29-.012ZM653.521,890.4a5.623,5.623,0,0,0-.619-.291,13.947,13.947,0,0,0-6.36-.543,4.391,4.391,0,0,0-3.292,2.034,4.141,4.141,0,0,0,2.557,6.123c.894.267,1.806.474,2.7.753a4.173,4.173,0,0,1,1.227.581.779.779,0,0,1-.177,1.418,3.457,3.457,0,0,1-.911.264,8.17,8.17,0,0,1-5.017-.879l-.975,3.168a11.146,11.146,0,0,0,5.193,1.059,8.705,8.705,0,0,0,5.15-1.409l-.524,1.386h4.243l.74-2.169a7.385,7.385,0,0,0,5.855.008,13.173,13.173,0,0,1,.472,1.407c.13.6.407.813,1.053.793,1.789-.054,3.581-.018,5.37-.019.174,0,.347-.022.6-.039v-3.652c.794,0,1.511.035,2.223-.006a5.473,5.473,0,0,0,.992-10.756,9.411,9.411,0,0,0-2.009-.21c-1.605-.029-3.212-.009-4.888-.009V900.7a1.073,1.073,0,0,1-.346-.5c-1.359-3.393-2.727-6.782-4.062-10.185a.826.826,0,0,0-.955-.626,27.942,27.942,0,0,1-2.864,0,.845.845,0,0,0-.976.675c-1.133,2.968-2.31,5.919-3.522,9a3.908,3.908,0,0,0-2.514-2.727c-.79-.312-1.632-.489-2.442-.755-.846-.278-1.693-.561-2.518-.9a.968.968,0,0,1-.583-1.075.94.94,0,0,1,.809-.843,4.577,4.577,0,0,1,1.411-.166c1.3.107,2.585.286,3.931.443Z",
    transform: "translate(-638.994 -882.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M666.235,894.665v-3.134a17.282,17.282,0,0,1,1.752.011,1.572,1.572,0,0,1,1.355,1.6,1.6,1.6,0,0,1-1.464,1.513C667.353,894.694,666.824,894.665,666.235,894.665Z",
    transform: "translate(-634.138 -880.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M657.31,891.943c.523,1.5,1.011,2.869,1.471,4.251a.465.465,0,0,1-.2.413,3.26,3.26,0,0,1-2.572,0c-.1-.042-.226-.245-.2-.326C656.285,894.866,656.78,893.463,657.31,891.943Z",
    transform: "translate(-636.005 -880.087)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSap);
export default __webpack_public_path__ + "static/media/logo-sap.0f240a4a6cb4d405ae066657ca0d46e4.svg";
export { ForwardRef as ReactComponent };